import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
  <div class="card shadow-sm">
    <div class="card-header card-header-bordered text-center"><h5 class="h2 mb-0"><slot name="label"></slot></h5></div>
    <div class="card-body text-center">
      <p class="mb-0 text-success">${until(ctx.__('<tt-wfpdx7nB>', 'Creates'))} ${ctx.rosterSummary.create}</p>
      <p class="mb-0 text-danger" >${until(ctx.__('<tt-SUhQFAIS>', 'Archives'))} ${ctx.rosterSummary.delete}</p>
      <p class="mb-0 text-blue"   >${until(ctx.__('<tt-vwx0/oLt>', 'Updates'))} ${ctx.rosterSummary.update}</p>
      <p class="mb-0 text-skipped">${until(ctx.__('<tt-NaY6aj/7>', 'Skipped'))} ${ctx.rosterSummary.skip}</p>
      ${ctx.rosterSummary.no_update > -1 ? html`<p class="mb-0">${until(ctx.__('<tt-+sXkA0z5>', 'No updates'))} ${ctx.rosterSummary.no_update}</p>` : ''}
    </div>
  </div>
`;
